// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"79":"fbaa7fc3","105":"a9a59294","217":"80d0fb74","274":"ce0b03af","279":"58a62c2e","473":"e74459e4","495":"d0ca626e","798":"c8ae48b3","819":"1e8eee0e"}[chunkId] + ".chunk.js";
};